import './ChatbotRow.pcss';
import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Link } from 'react-router-dom';
import useRouter from 'use-react-router';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { FormattedBot } from '@mm/state/interfaces/view';
import {
  GridCell,
  GridRow,
} from '../../../../../../../../common/components/Grid/Grid';
import { CHATBOT_EDITOR } from '../../../../../../../../common/constants/routes';
import Button from '../../../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { StoreState } from '@mm/state/store-interfaces';
import { openShareBotModal } from '@mm/state/modules/modalsState/actions';
import { ThreeDotMenu } from '../../../../../../../../common/components/ThreeDotMenu/ThreeDotMenu';

type OuterProps = {
  openConfirmDeleteChatbotModal: (bot: ChatbotModel, companyId: number) => void;
  attachToFacebookPage: (
    botId: number,
    facebookPage: ConnectedPageModel,
  ) => void;
  openConfirmChangeBotStatusModal: (
    botId: number,
    facebookPage: ConnectedPageModel,
  ) => void;
  bot: FormattedBot;
  page: ConnectedPageModel | undefined;
  companyId: number;
  showShareButton: boolean;
  gridTemplateColumns: string;
  canDeleteBots: boolean;
};

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & PropsFromDispatch;

const ChatbotRow = (props: Props) => {
  const { history } = useRouter();
  const {
    bot,
    companyId,
    openConfirmDeleteChatbotModal,
    attachToFacebookPage,
    page,
    openConfirmChangeBotStatusModal,
    openShareBotModal,
    showShareButton,
    gridTemplateColumns,
    canDeleteBots,
  } = props;
  const { id, name, formattedCreatedAt, isActive, searchToken } = bot;
  const attachFunction =
    page && page.activeBotId
      ? openConfirmChangeBotStatusModal
      : attachToFacebookPage;

  const actions = [
    { name: 'Edit', value: 'edit' },
    { name: 'Share', value: 'share', disabled: !showShareButton },
    { name: 'Delete', value: 'delete', disabled: !canDeleteBots },
  ];

  const onSelectItem = (value: string) => {
    if (value === 'edit') {
      history.push(`${CHATBOT_EDITOR}/${id}/home`);
    }
    if (value === 'share') {
      openShareBotModal(searchToken);
    }
    if (value === 'delete') {
      openConfirmDeleteChatbotModal(bot, companyId);
    }
  };

  return (
    <GridRow className="chatbot-row" gridTemplateColumns={gridTemplateColumns}>
      <GridCell className="chatbot-row__name">
        <Link
          to={`${CHATBOT_EDITOR}/${id}/home`}
          className="chatbot-row__bot-name-link"
        >
          {name}
        </Link>
      </GridCell>

      <GridCell fr={2} className="chatbot-row__status">
        {isActive && (
          <div className="chatbot-row__active-text">Chatbot is active now</div>
        )}

        {!isActive && page && (
          <Button
            className="chatbot-row__active-button"
            onClick={() => attachFunction(id, page)}
          >
            Activate
          </Button>
        )}
      </GridCell>

      <GridCell fr={2} className="chatbot-row__date">
        {formattedCreatedAt}
      </GridCell>

      <GridCell overflowable className="chatbot-row__actions">
        <ThreeDotMenu elements={actions} selectItem={onSelectItem} />
      </GridCell>
    </GridRow>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  openShareBotModal: (searchToken: string) =>
    dispatch(openShareBotModal(searchToken)),
});

const enhance = compose<PropsFromDispatch, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(ChatbotRow);
